import { Button } from '../../Button';

interface CompletionStepProps {
  onLogin: () => void;
}

export default function CompletionStep({ onLogin }: CompletionStepProps) {
  return (
    <>
      <div className="flex h-full flex-col items-center justify-center">
        {/* Main Content */}
        <div className="flex flex-col items-center justify-center space-y-6 text-center">
          {/* Check Icon */}
          <div className="flex size-12 items-center justify-center">
            <img src="/agent/icon-check-circle-blue.svg" alt="登録完了" width="48" height="48" />
          </div>

          {/* Title */}
          <h2 className="my-0 text-base font-bold text-primary">登録完了</h2>
        </div>

        {/* Login Button */}
        <div className="mx-auto w-[320px] pt-12">
          <Button onClick={onLogin} color="primary" size="lg" full>
            さっそくログインして始める
          </Button>
        </div>
      </div>
    </>
  );
}
